var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"main"},[_c('premium-hero',{attrs:{"testimonials":_vm.allFeedbacks}}),_c('Promo'),_c('About',{attrs:{"is-gray":false}}),_c('pricing',{attrs:{"is-gray":false}}),_c('site-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }